import { FormNode, DynamoNode, ElementNode, PageNode, TableNode, RowNode, CellNode, LabelNode } from "dynamo-models";
import { AbsComponentFactory, EditorPrimaryComponentFactory, ToolboxCardFactory } from "..";
import { MetaNode, ToolboxContainerNode } from "../..";
import { NodeProps } from ".";
import { IToolboxProps } from "..";
import { ToolboxLayoutNode, ToolboxGroupType } from "../../supportNodes";
import { ReadOnlyComponentFactory } from "../factories";

export interface ISessionNodeDescriptor {
    name: string;

    label?: string;

    customBuilder?: () => ElementNode;
}

export const createSessionNodeDesc = (name: string, customBuilder?: () => ElementNode, label?: string): ISessionNodeDescriptor => ({
    name,
    label,
    customBuilder,
})

export class EditorConfigurator {
    constructor(formNode?: FormNode) {
        this.form = formNode !== undefined ? formNode : new FormNode();
        this.toolboxContainer = new ToolboxContainerNode();
        this.metaNode = new MetaNode(this.form, this.toolboxContainer);
    }

    public form: FormNode;

    private primaryFactory: AbsComponentFactory = new EditorPrimaryComponentFactory();

    private toolboxFactory: AbsComponentFactory = new ToolboxCardFactory();

    private previewFactory: AbsComponentFactory = new ReadOnlyComponentFactory();

    private metaNode: MetaNode;

    private toolboxContainer: ToolboxContainerNode;

    private canAddNewPages: boolean = false;

    private maxToolboxHeight?: number;

    public addToolboxTemplate(nodeCreator: () => ElementNode, index?: number, label?: string) {
        this.toolboxContainer.addTemplateChild(nodeCreator, index, label);
    }

    public addTemplateGroup(type: ToolboxGroupType, index?: number) {
        this.toolboxContainer.tryAddChild(new ToolboxLayoutNode(type), index);
    }

    public addCustomSessionGroup(label: string, sessionNodeDesc: ISessionNodeDescriptor[], index?: number) {
        this.toolboxContainer.tryAddChild(new ToolboxLayoutNode(ToolboxGroupType.Custom, label, () => {
            return sessionNodeDesc.map(({ name, customBuilder }) => {
                if (customBuilder !== undefined) {
                    return customBuilder();
                }

                const node = new LabelNode();
                node.dynamicName = name;
                node.text = `\$\{${name}\}`;
                return node;
            });
        }), index);
    }

    public addToolboxField(node: DynamoNode, index?: number) {
        this.toolboxContainer.addSingleUseChild(node, index)
    }

    public allowNewPages() {
        this.canAddNewPages = true;
    }

    public setMaxToolboxHeight(height: number) {
        this.maxToolboxHeight = height;
    }

    public generatePrimaryProps(): NodeProps<FormNode> {
        return new NodeProps(this.form, this.metaNode, this.primaryFactory, this.previewFactory, undefined);
    }

    public generateToolboxProps(): IToolboxProps {
        const props: IToolboxProps = {
            factory: this.toolboxFactory,
            nodes: this.metaNode,
            allowNewPages: this.canAddNewPages,
            maxHeight: this.maxToolboxHeight,
        }

        return props;
    }
}